import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from '@/app/store/store';
import { queryClient } from '@/app/providers/queryClient';
import { AuthProvider } from '../../features/auth/providers/AuthProvider';
import { ThemeProvider } from './ThemeProvider';
import { DeviceProvider } from './DeviceProvider';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { AppLoader } from '@/shared/components';

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <ErrorBoundary>
            <Provider store={store}>
                <PersistGate loading={<AppLoader />} persistor={persistor}>
                    <DeviceProvider>
                        <QueryClientProvider client={queryClient}>
                            <AuthProvider>
                                <ThemeProvider>
                                    {children}
                                    <ReactQueryDevtools initialIsOpen={false} />
                                </ThemeProvider>
                            </AuthProvider>
                        </QueryClientProvider>
                    </DeviceProvider>
                </PersistGate>
            </Provider>
        </ErrorBoundary>
    );
};
